const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:4998";

async function getAuthHeaders(includeJson = false) {
  const { supabase } = await import("../../supabase");
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    throw new Error("No active session");
  }
  const headers = { Authorization: `Bearer ${session.access_token}` };
  if (includeJson) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}

export async function fetchScreenResults() {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/api/screen-results`, { headers });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to fetch screen results");
  }
  return data.screen_results || [];
}

export async function deleteScreenResult(resultId) {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/api/screen-results/${resultId}`, {
    method: "DELETE",
    headers
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to delete screen result");
  }
  return data;
}
